/**
 *
 * @description 热门专题内容 曝光
 */
export function reportHotTopicContentExposure(params: {
    /** 热门专题id */
    hot_topic_id: string

    /** 帖子id */
    content_id: string

    /** 帖子类型 例如 推荐帖、非推荐帖 */
    content_type: string

    /** 所属tab */
    tab_name: string

    /** 发布时间, 毫秒 */
    public_time: number
}) {
    window['sensors'].track('HotTopicContentExposure', params)
}

/**
 *
 * @description 热门专题内容 点击
 */
export function reportHotTopicContentClick(params: {
    /** 热门专题id */
    hot_topic_id: string

    /** 帖子id */
    content_id: string

    /** 帖子类型 例如 推荐帖、非推荐帖 */
    content_type: string

    /** 发布人id */
    anthor_id: string

    /** 发布时间, 毫秒 */
    public_time: number
}) {
    window['sensors'].track('HotTopicContentClick', params)
}

/**
 *
 * @description 热门专题内容 浏览
 */
export function reportHotTopicContentView(params: {
    /** 热门专题id */
    hot_topic_id: string

    /** 帖子id */
    content_id: string

    /** 帖子类型 例如 推荐帖、非推荐帖 */
    content_type: string

    /** 发布人id */
    anthor_id: string

    /** 发布人名称 */
    anthor_name: string

    /** 发布时间, 毫秒 */
    public_time: number

    /*** 浏览时长, 毫秒 */
    view_time: number
}) {
    window['sensors'].track('HotTopicContentView', params)
}

/**
 *
 * @description 上报 热门专题内容互动
 */
export function reportHotTopicContentInteraction(params: {
    /** 热门专题id */
    hot_topic_id: string

    /** 帖子id */
    content_id: string

    /** 帖子类型 例如 推荐帖、非推荐帖 */
    content_type: string

    /** 发布人id */
    anthor_id: string

    /** 所属tab */
    tab_name: string

    /** 发布时间, 毫秒 */
    public_time: number

    /** 互动类型 */
    interactivity_type: '点赞' | '评论' | '转发'
}) {
    window['sensors'].track('HotTopicContentInteraction', params)
}

/**
 *
 * @description 上报 热门专题互动
 */
export function reportHotTopicInteraction(params: {
    /** 热门专题id */
    hot_topic_id: string

    /** 互动类型 */
    interactivity_type: '发帖' | '点赞'
}) {
    window['sensors'].track('HotTopicInteraction', params)
}
